<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Minhas tarefas"
      Pagina="Minhas tarefas"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="col-12">
              <div class="card card-blue">
                <div class="card-header">
                  <h3 class="card-title">Board de tarefas</h3>
                  <div class="card-tools">
                    <button (click)="showModalNovo()" class="btn btn-primary">
                      <i class="fa fa-plus me-1"></i> Nova tarefa
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <table *ngIf="token?.seguranca != 'Admin' && token?.seguranca != 'GestorAdmin'" class="table table-striped table-head-fixed">
                    <thead>
                    <tr style="border: 1px solid rgba(88, 96, 110, 0.17)">
                      <th class="tamanho-titulo coluna">A fazer</th>
                      <th class="tamanho-titulo coluna-azul">Em andamento</th>
                      <th class="tamanho-titulo coluna">Validação</th>
                      <th class="tamanho-titulo coluna-azul">Fechada</th>
                    </tr>
                    </thead>
                    <tbody cdkDropListGroup>
                    <tr style="border: 1px solid rgba(88, 96, 110, 0.17)">
                      <td class="coluna linkDetalhes"
                          (click)="showModalNovo(1)"
                          cdkDropList
                          [cdkDropListData]="listaTarefasFazer.itens"
                          (cdkDropListDropped)="drop($event, 1)">
                        <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasFazer.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                          <div *ngIf="item.nova" class="ribbon-wrapper">
                            <div class="ribbon bg-primary">
                              Nova
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="tarefa-header">
                              <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                            </div>
                            <div class="tarefa-content">
                              <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                              <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                              <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>
                            </div>
                            <div class="tarefa-footer">
                              <div class="tarefa-info" [title]="item.responsavel">
                                <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                              </div>
                              <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="coluna-azul linkDetalhes"
                          (click)="showModalNovo(2)"
                          cdkDropList
                          [cdkDropListData]="listaTarefasEmAndamento.itens"
                          (cdkDropListDropped)="drop($event, 2)">
                        <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasEmAndamento.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                          <div *ngIf="item.nova" class="ribbon-wrapper">
                            <div class="ribbon bg-primary">
                              Nova
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="tarefa-header">
                              <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                            </div>
                            <div class="tarefa-content">
                              <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                              <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                              <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                            </div>
                            <div class="tarefa-footer">
                              <div class="tarefa-info" [title]="item.responsavel">
                                <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                              </div>
                              <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="coluna linkDetalhes"
                          (click)="showModalNovo(3)"
                          cdkDropList
                          [cdkDropListData]="listaTarefasVerificacao.itens"
                          (cdkDropListDropped)="drop($event, 3)">
                        <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasVerificacao.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                          <div *ngIf="item.nova" class="ribbon-wrapper">
                            <div class="ribbon bg-primary">
                              Nova
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="tarefa-header">
                              <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                            </div>
                            <div class="tarefa-content">
                              <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                              <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                              <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                            </div>
                            <div class="tarefa-footer">
                              <div class="tarefa-info" [title]="item.responsavel">
                                <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                              </div>
                              <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="coluna-azul linkDetalhes"
                          (click)="showModalNovo(4)"
                          cdkDropList
                          [cdkDropListData]="listaTarefasFechada.itens"
                          (cdkDropListDropped)="drop($event, 4)">
                        <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasFechada.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                          <div *ngIf="item.nova" class="ribbon-wrapper">
                            <div class="ribbon bg-primary">
                              Nova
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="tarefa-header">
                              <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                            </div>
                            <div class="tarefa-content">
                              <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                              <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                              <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                            </div>
                            <div class="tarefa-footer">
                              <div class="tarefa-info" [title]="item.responsavel">
                                <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                              </div>
                              <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table *ngIf="token?.seguranca == 'Admin' || token?.seguranca == 'GestorAdmin'" class="table table-striped table-head-fixed">
                    <thead>
                      <tr style="border: 1px solid rgba(88, 96, 110, 0.17)">
                        <th class="tamanho-titulo16 coluna-azul">Em planejamento</th>
                        <th class="tamanho-titulo16 coluna">A fazer</th>
                        <th class="tamanho-titulo16 coluna-azul">Em andamento</th>
                        <th class="tamanho-titulo16 coluna">Validação</th>
                        <th class="tamanho-titulo16 coluna-azul">Fechada</th>
                      </tr>
                    </thead>
                    <tbody cdkDropListGroup>
                      <tr style="border: 1px solid rgba(88, 96, 110, 0.17)">
                        <td class="coluna-azul linkDetalhes"
                            (click)="showModalNovo(0)"
                            cdkDropList
                            [cdkDropListData]="listaTarefasPlanejamento.itens"
                            (cdkDropListDropped)="drop($event, 0)">
                            <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasPlanejamento.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                              <div *ngIf="item.nova" class="ribbon-wrapper">
                                <div class="ribbon bg-primary">
                                  Nova
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="tarefa-header">
                                  <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                                </div>
                                <div class="tarefa-content">
                                  <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                                  <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                                  <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                                </div>
                                <div class="tarefa-footer">
                                  <div class="tarefa-info" [title]="item.responsavel">
                                    <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                                  </div>
                                  <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                    <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                        </td>
                        <td class="coluna linkDetalhes"
                            (click)="showModalNovo(1)"
                            cdkDropList
                            [cdkDropListData]="listaTarefasFazer.itens"
                            (cdkDropListDropped)="drop($event, 1)">
                            <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasFazer.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                            <div *ngIf="item.nova" class="ribbon-wrapper">
                              <div class="ribbon bg-primary">
                                Nova
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="tarefa-header">
                                <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                              </div>
                              <div class="tarefa-content">
                                <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                                <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                                <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                              </div>
                              <div class="tarefa-footer">
                                <div class="tarefa-info" [title]="item.responsavel">
                                  <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                                </div>
                                <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                  <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="coluna-azul linkDetalhes"
                            (click)="showModalNovo(2)"
                            cdkDropList
                            [cdkDropListData]="listaTarefasEmAndamento.itens"
                            (cdkDropListDropped)="drop($event, 2)">
                            <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasEmAndamento.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                            <div *ngIf="item.nova" class="ribbon-wrapper">
                              <div class="ribbon bg-primary">
                                Nova
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="tarefa-header">
                                <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                              </div>
                              <div class="tarefa-content">
                                <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                                <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                                <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                              </div>
                              <div class="tarefa-footer">
                                <div class="tarefa-info" [title]="item.responsavel">
                                  <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                                </div>
                                <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                  <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="coluna linkDetalhes"
                            (click)="showModalNovo(3)"
                            cdkDropList
                            [cdkDropListData]="listaTarefasVerificacao.itens"
                            (cdkDropListDropped)="drop($event, 3)">
                           <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasVerificacao.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                            <div *ngIf="item.nova" class="ribbon-wrapper">
                              <div class="ribbon bg-primary">
                                Nova
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="tarefa-header">
                                <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                              </div>
                              <div class="tarefa-content">
                                <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                                <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                                <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                              </div>
                              <div class="tarefa-footer">
                                <div class="tarefa-info" [title]="item.responsavel">
                                  <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                                </div>
                                <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                  <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="coluna-azul linkDetalhes"
                            (click)="showModalNovo(4)"
                            cdkDropList
                            [cdkDropListData]="listaTarefasFechada.itens"
                            (cdkDropListDropped)="drop($event, 4)">
                           <div (click)="buscarDetalheTarefa(item.id); $event.stopPropagation()" *ngFor="let item of listaTarefasFechada.itens" class="card card-tarefa linkDetalhes" cdkDrag>
                            <div *ngIf="item.nova" class="ribbon-wrapper">
                              <div class="ribbon bg-primary">
                                Nova
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="tarefa-header">
                                <span class="tarefa-tipo">{{item.tipoTarefa}}</span>
                              </div>
                              <div class="tarefa-content">
                                <span class="tarefa-titulo"><b>Tarefa:</b> {{ item.descricao }}</span>
                                <span class="tarefa-processo" *ngIf="item.atendimentoId > 0"><b>Atendimento:</b> {{ item.atendimento }}</span>
                                <span class="tarefa-processo" *ngIf="item.processoId > 0"><b>Processo:</b> {{ item.processo }}</span>

                              </div>
                              <div class="tarefa-footer">
                                <div class="tarefa-info" [title]="item.responsavel">
                                  <i class="fa fa-user me-1"></i> {{ item.responsavel }}
                                </div>
                                <div class="tarefa-info" *ngIf="item.dataPrevisaoFinalizacao && (item.dataPrevisaoFinalizacao | date:'yyyy') !== '0001'">
                                  <i class="fa fa-clock-o me-1"></i> {{ item.dataPrevisaoFinalizacao | date:"dd/MM/yyyy" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-nova (atualizarLista)="buscarLista()">
</app-nova>
<app-detalhes (atualizarLista)="buscarLista()">
</app-detalhes>
